import { OctagonXIcon } from 'lucide-react';
import { toast } from 'sonner';
import { ApiError } from './api';

/**
 * Error toast. Always shows the request id when there is one, with a copy
 * button, because that id is how a developer finds the `error_logs` row.
 *
 * One toast per failed request: a mutation's own `onError` and the global
 * mutation handler can both report the same error, and the second now replaces
 * the first instead of stacking. The error icon is the close button.
 */
export function toastError(err: unknown, fallback = 'Something went wrong'): void {
  const message = err instanceof Error && err.message ? err.message : fallback;
  const requestId = err instanceof ApiError ? err.requestId : undefined;
  const id = requestId ?? `error:${message}`;
  toast.error(message, {
    id,
    icon: (
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => toast.dismiss(id)}
        className="cursor-pointer rounded-sm hover:opacity-70 focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      >
        <OctagonXIcon className="size-4" />
      </button>
    ),
    description: requestId ? `Request id: ${requestId}` : undefined,
    action: requestId
      ? {
          label: 'Copy id',
          onClick: () => void navigator.clipboard?.writeText(requestId),
        }
      : undefined,
    duration: 10_000,
  });
}

export function toastSuccess(message: string): void {
  toast.success(message);
}
